import { P00039DataRxTxIndex } from '../../P00039Sync';
import { IProduct } from '../../../IProduct';
import { Pool } from '../../../../../../apis/pool.api';

export function P00080InstallationReset(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
) {
  editValue(
    P00039DataRxTxIndex.Altimeo_Control,
    'alCResetUsine',
    1,
    null,
    productClass,
  );
}
